// extracted by mini-css-extract-plugin
export var quillEditor = "_jw-1";
export var variable = "_jw-0";